module.exports = __webpack_public_path__ + "assets/img/0221.131f533a.png";